import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import MultiClamp from 'react-multi-clamp';
import InfiniteScroll from 'react-infinite-scroller';
import ReactTooltip from 'react-tooltip';
import { Progress } from 'react-sweet-progress';

import global from '../../stores/GlobalStore';
import ShowDetails from '../Show/ShowDetails';
import LoadingSpinner from '../Shared/LoadingSpinner';
import ClippList from '../Show/ClippList';
import 'react-activity-feed/dist/index.css';
import history from '../../auth/history';
import { stripHtml } from '../../utils/string';
import { formatDuration } from '../../utils/podcastUtils';
import explicitIcon from '../../styles/images/explicit.png';

import './styles/ShowsLandingPage.scss';
import './styles/ShowPage.scss';
import 'react-sweet-progress/lib/style.css';
import { Tab, TabList, TabPanel, Tabs } from 'react-web-tabs';

const QUERY_SIZE = 20;
const ASC = 'asc';
const DESC = 'desc';

export default class ShowPage extends React.Component {
  constructor(props) {
    super(props);

    this.scrollWindow = React.createRef();

    this.state = {
      isLoading: true,
      isLoadingClipps: true,
      hasMore: true,
      show: {},
      episodes: [],
      clipps: [],
      resultCount: null,
      resultCountClipps: null,
      isFollowing: false,
      orderBy: DESC,
    };

    this.searchTermRef = React.createRef();
  }

  componentDidMount() {
    const showId = this.props.match.params && this.props.match.params.showId;

    if (showId) {
      global()
        .getPodcastStore()
        .getShow(showId, show => {
          const isFollowing = this.props.user && show.followers && show.followers.includes(this.props.user.id);
          this.props.setActiveShow(show);
          this.setState({ show, isFollowing });
        });
    } else {
      // Error state?
    }
  }

  componentDidCatch() {
    /* noop */
  }

  toggleLoginModal = () => {
    window.dispatchEvent(new CustomEvent('OPEN_LOGIN_MODAL', { detail: {} }));
  };

  followShow = () => {
    if (this.props.user) {
      this.setState({ isFollowing: true });

      global()
        .getPodcastStore()
        .followShow(this.state.show.id, this.props.user.id, result => {
          if (!result) {
            this.setState({ isFollowing: false });
          } else {
            this.setState({ show: result });
          }
        });
    }
  };

  unfollowShow = () => {
    if (this.props.user) {
      this.setState({ isFollowing: false });

      global()
        .getPodcastStore()
        .unfollowShow(this.state.show.id, this.props.user.id, result => {
          if (!result) {
            this.setState({ isFollowing: true });
          } else {
            this.setState({ show: result });
          }
        });
    }
  };

  loadMoreEpisodes = () => {
    const { show } = this.state;
    const oldEpisodes = _.clone(this.state.episodes);
    const searchTerm = this.searchTermRef.current && this.searchTermRef.current.value;

    if (show && show.id && !searchTerm) {
      setTimeout(() => {
        global()
          .getPodcastStore()
          .fetchEpisodes(
            show.id,
            oldEpisodes.length,
            QUERY_SIZE,
            this.state.orderBy,
            (newEpisodes, meta = {}, show) => {
              if (newEpisodes && newEpisodes.length) {
                const episodes = oldEpisodes.concat(newEpisodes);
                this.setState({ episodes: episodes, hasMore: true, show, isLoading: false });
              } else {
                this.setState({ hasMore: false, isLoading: false });
              }
            }
          );
      }, 500);
    } else if (show && show.id && searchTerm) {
      setTimeout(() => {
        global()
          .getPodcastStore()
          .searchEpisodesInShow(
            show.id,
            searchTerm,
            oldEpisodes.length,
            QUERY_SIZE,
            this.state.orderBy,
            (newEpisodes, meta) => {
              if (newEpisodes && newEpisodes.length) {
                const episodes = oldEpisodes.concat(newEpisodes);
                this.setState({ episodes: episodes, hasMore: true, resultCount: meta.size, isLoading: false });
              } else {
                this.setState({ hasMore: false, resultCount: meta.size, isLoading: false });
              }
            }
          );
      }, 500);
    }
  };

  loadMoreClipps = () => {
    const { show } = this.state;
    const oldClipps = _.clone(this.state.clipps);
    const searchTerm = this.searchTermRef.current && this.searchTermRef.current.value;

    if (show && show.id && !searchTerm) {
      setTimeout(() => {
        global()
          .getPodcastStore()
          .fetchClippsForShow(
            { showId: show.id, from: oldClipps.length, size: QUERY_SIZE, order: this.state.orderBy },
            (newClipps, meta = {}) => {
              if (newClipps && newClipps.length) {
                const clipps = oldClipps.concat(newClipps);
                this.setState({ clipps, hasMore: true, resultCountClipps: meta.size, isLoadingClipps: false });
              } else {
                this.setState({ hasMore: false, resultCountClipps: meta.size, isLoadingClipps: false });
              }
            }
          );
      }, 500);
    } else if (show && show.id && searchTerm) {
      /*
            setTimeout(() => {
                global().getPodcastStore().searchEpisodesInShow(show.id, searchTerm, oldEpisodes.length, QUERY_SIZE, this.state.orderBy, (newEpisodes, meta) => {
                    if (newEpisodes && newEpisodes.length) {
                        const episodes = oldEpisodes.concat(newEpisodes);
                        this.setState({ episodes: episodes, hasMore: true, resultCount: meta.size, isLoading: false })
                    } else {
                        this.setState({ hasMore: false, resultCount: meta.size, isLoading: false })
                    }
                });
            }, 500);
             */
    }
  };

  toggleSort = () => {
    this.setState({ orderBy: this.state.orderBy === ASC ? DESC : ASC, isLoading: true, episodes: [] }, () => {
      this.loadMoreEpisodes();
    });
  };

  searchEpisodesInShow = e => {
    e.preventDefault();

    this.setState({ isLoading: true });
    const searchTerm = this.searchTermRef.current.value;

    global()
      .getPodcastStore()
      .searchEpisodesInShow(this.state.show.id, searchTerm, 0, QUERY_SIZE, this.state.orderBy, (result, meta) => {
        if (meta.size > QUERY_SIZE) {
          this.setState({ isLoading: false, episodes: result, resultCount: meta.size, hasMore: true });
        } else {
          this.setState({ isLoading: false, episodes: result, resultCount: meta.size, hasMore: false });
        }
      });
  };

  searchWatcher = e => {
    e.preventDefault();

    const searchTerm = this.searchTermRef.current.value;

    if (!searchTerm) {
      this.setState({ isLoading: true, episodes: [], resultCount: null, hasMore: true });
    }
  };

  renderReleaseDate = publishDate => {
    const date = moment(publishDate);

    return moment().diff(date, 'hours') > 24 ? date.format('MMM Do, YYYY') : date.fromNow();
  };

  renderEpisodes = () => {
    const { show, episodes, clipps, resultCountClipps, orderBy, isLoadingClipps } = this.state;
    const { activeEpisode, user } = this.props;
    const disableClippsTabs = false;

    return (
      <>
        {disableClippsTabs ? (
          <InfiniteScroll
            pageStart={0}
            loadMore={this.loadMoreEpisodes.bind(this)}
            hasMore={this.state.hasMore}
            loader={
              <div className='loader' style={{ height: '100px' }} key={0}>
                <LoadingSpinner />
              </div>
            }
            useWindow={false}
            getScrollParent={() => this.scrollWindow.current}
          >
            <div className='episode-search'>
              <form onSubmit={this.searchEpisodesInShow} onChange={this.searchWatcher}>
                <input
                  className='episode-search-input'
                  type='text'
                  ref={this.searchTermRef}
                  placeholder='Search Episodes...'
                  required
                />
                <input className='episode-search-btn' type='submit' value='Search' />
              </form>
              {!!this.state.resultCount && <div className='result-count'>{`Results: ${this.state.resultCount}`}</div>}
              <div className='order-by' onClick={this.toggleSort}>
                {this.state.orderBy === ASC ? (
                  <i className='far fa-sort-amount-up' />
                ) : (
                  <i className='far fa-sort-amount-down' />
                )}
              </div>
            </div>
            {episodes.map(episode => {
              const isPlaying = episode.id === activeEpisode.id && activeEpisode.isPlaying;
              const progress =
                (episode.progress && episode.progress.length && episode.progress[0].episodeData.percentage) || 0;

              return (
                <a href={`/e/${episode.id}`}>
                  <div
                    className='episode-container'
                    key={episode.id}
                  >
                    <ReactTooltip resizeHide={true} className='tooltip' effect='solid' delayShow={500} />
                    <div className='episode-title'>{episode.title}</div>
                    <div className='open-episode-btn'>
                      <i className='fas fa-chevron-right' />
                    </div>
                    <div className='episode-description'>
                      {episode.description && (
                        <MultiClamp ellipsis='...' clamp={3}>
                          {stripHtml(episode.description)}
                        </MultiClamp>
                      )}
                    </div>
                    <div className='episode-details'>
                      {episode.isExplicit && (
                        <span className='is-explicit' data-tip='Explicit'>
                          <img src={explicitIcon} alt='Episode is explicit' width={12} />
                        </span>
                      )}
                      {episode.publishDate && (
                        <div className='episode-release-date' data-tip='Release Date'>
                          <i className='fal fa-calendar-alt' />
                          <span className='release-date'>{this.renderReleaseDate(episode.publishDate)}</span>
                        </div>
                      )}
                      {episode.duration && (
                        <div className='episode-duration' data-tip='Duration'>
                          <i className='far fa-stopwatch' />
                          <span className='duration'>{formatDuration(episode.duration)}</span>
                        </div>
                      )}
                      <div
                        className='play-episode'
                        data-tip={`${isPlaying ? 'Close' : 'Open'} Episode`}
                      >
                        <i className={`fas ${isPlaying ? 'fa-pause-circle' : 'fa-play-circle'}`} />
                      </div>
                      <div
                        className='share-episode'
                        data-tip='Share Episode'
                        onClick={this.props.shareEpisode.bind(this, episode)}
                      >
                        <i className='fas fa-share' />
                      </div>
                      {user && (
                        <div className='show-progress' data-tip='Your Progress'>
                          <Progress
                            percent={progress}
                            theme={{
                              success: {
                                symbol: `Done`,
                              },
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </a>
              );
            })}
          </InfiniteScroll>
        ) : (
          <Tabs defaultTab='episodes'>
            <TabList>
              <Tab tabFor='episodes'>Episodes</Tab>
              <Tab tabFor='clipps'>Clipps</Tab>
            </TabList>
            <TabPanel tabId='episodes'>
              <InfiniteScroll
                pageStart={0}
                loadMore={this.loadMoreEpisodes.bind(this)}
                hasMore={this.state.hasMore}
                loader={
                  <div className='loader' style={{ height: '100px' }} key={0}>
                    <LoadingSpinner />
                  </div>
                }
                useWindow={false}
                getScrollParent={() => this.scrollWindow.current}
              >
                <div className='episode-search'>
                  <form onSubmit={this.searchEpisodesInShow} onChange={this.searchWatcher}>
                    <input
                      className='episode-search-input'
                      type='text'
                      ref={this.searchTermRef}
                      placeholder='Search Episodes...'
                      required
                    />
                    <input className='episode-search-btn' type='submit' value='Search' />
                  </form>
                  {!!this.state.resultCount && (
                    <div className='result-count'>{`Results: ${this.state.resultCount}`}</div>
                  )}
                  <div className='order-by' onClick={this.toggleSort}>
                    {this.state.orderBy === ASC ? (
                      <i className='far fa-sort-amount-up' />
                    ) : (
                      <i className='far fa-sort-amount-down' />
                    )}
                  </div>
                </div>
                {episodes.map(episode => {
                  const isPlaying = episode.id === activeEpisode.id && activeEpisode.isPlaying;
                  const progress =
                    (episode.progress && episode.progress.length && episode.progress[0].episodeData.percentage) || 0;

                  return (
                    <a href={`/e/${episode.id}`}>
                      <div
                        className='episode-container'
                        key={episode.id}
                      >
                        <ReactTooltip resizeHide={true} className='tooltip' effect='solid' delayShow={500} />
                        <div className='episode-title'>{episode.title}</div>
                        <div className='open-episode-btn'>
                          <i className='fas fa-chevron-right' />
                        </div>
                        <div className='episode-description'>
                          {episode.description && (
                            <MultiClamp ellipsis='...' clamp={3}>
                              {stripHtml(episode.description)}
                            </MultiClamp>
                          )}
                        </div>
                        <div className='episode-details'>
                          {episode.isExplicit && (
                            <span className='is-explicit' data-tip='Explicit'>
                              <img src={explicitIcon} alt='Episode is explicit' width={12} />
                            </span>
                          )}
                          {episode.publishDate && (
                            <div className='episode-release-date' data-tip='Release Date'>
                              <i className='fal fa-calendar-alt' />
                              <span className='release-date'>{this.renderReleaseDate(episode.publishDate)}</span>
                            </div>
                          )}
                          {episode.duration && (
                            <div className='episode-duration' data-tip='Duration'>
                              <i className='far fa-stopwatch' />
                              <span className='duration'>{formatDuration(episode.duration)}</span>
                            </div>
                          )}
                          <div
                            className='play-episode'
                            data-tip={`${isPlaying ? 'Close' : 'Open'} Episode`}
                          >
                            <i className={`fas ${isPlaying ? 'fa-pause-circle' : 'fa-play-circle'}`} />
                          </div>
                          <div
                            className='share-episode'
                            data-tip='Share Episode'
                            onClick={this.props.shareEpisode.bind(this, episode)}
                          >
                            <i className='fas fa-share' />
                          </div>
                          {user && (
                            <div className='show-progress' data-tip='Your Progress'>
                              <Progress
                                percent={progress}
                                theme={{
                                  success: {
                                    symbol: `Done`,
                                  },
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </a>
                  );
                })}
              </InfiniteScroll>
            </TabPanel>
            <TabPanel tabId='clipps'>
              <ClippList
                user={user}
                isLoading={isLoadingClipps}
                show={show}
                items={clipps}
                loadMore={this.loadMoreClipps}
                searchFunc={this.loadMoreClipps}
                redirectTo={this.redirectToClipp}
                searchWatcher={this.searchWatcher}
                searchTermRef={this.searchTermRef}
                resultCount={resultCountClipps}
                itemName='Clipp'
                orderBy={orderBy}
              />
            </TabPanel>
          </Tabs>
        )}
      </>
    );
  };

  render() {
    const { darkMode } = this.props;
    const { episodes, isLoading } = this.state;

    return (
      <div className='user-feed'>
        <div className='mainPanel' ref={this.scrollWindow} style={{ background: darkMode ? 'rgb(11, 19, 61)' : '' }}>
          <div
            className='show-list-container'
            style={{
              background: darkMode ? 'rgb(11, 19, 61)' : '',
              borderLeft: darkMode ? '1px solid rgba(255, 255, 255, .2)' : '',
              borderRight: darkMode ? '1px solid rgba(255, 255, 255, .2)' : '',
            }}
          >
            <ShowDetails
              show={this.state.show}
              user={this.props.user}
              isFollowing={this.state.isFollowing}
              toggleLoginModal={this.toggleLoginModal}
              unfollowShow={this.unfollowShow}
              followShow={this.followShow}
            />
            {_.size(episodes) || isLoading ? this.renderEpisodes() : <div className='no-results'>No Results</div>}
          </div>
        </div>
      </div>
    );
  }
}

ShowPage.propTypes = {
  user: PropTypes.object,
  darkMode: PropTypes.bool,
  activeEpisode: PropTypes.object,
  episodePlaying: PropTypes.bool,
  setActiveEpisode: PropTypes.func.isRequired,
  setActiveShow: PropTypes.func.isRequired,
  shareEpisode: PropTypes.func.isRequired,
};

ShowPage.defaultProps = {
  user: {},
  darkMode: false,
};
